export const  statisticsTodayData= [
  {
    class: 'progress progress-img',
    span:6,
    isBigImg: false,
    isProgress: false,
    icon:'statistics1',
    name: '今日新增客户',
    num: 0,
    id:"increaseLoan"
  },
  {
    class: 'progress progress-img',
    isBigImg: false,
    span:6,
    isProgress: false,
    icon:'statistics2',
    name: '今日提交进件',
    num: 0,
    id:"increaseCommit"
  },
  {
    class: 'progress progress-img',
    isBigImg: false,
    span:6,
    isProgress: false,
    icon:'statistics3',
    name: '今日弃单数',
    num: 0,
    id:"increaseDiscard"
  },
  {
    class: 'progress progress-img',
    isBigImg: false,
    span:6,
    isProgress: false,
    icon:'statistics5',
    name: '今日放款数',
    num: 0,
    id:"increaseLending"
  },
  {
    class: 'progress progress-img',
    isBigImg: false,
    span:6,
    isProgress: false,
    icon:'statistics4',
    name: '今日放款总额(元)',
    num: 0,
    id:"increaseLendingAmount"
  },
  {
    class: 'progress progress-img',
    isBigImg: false,
    span:6,
    isProgress: false,
    icon:'statistics6',
    name: '本月新增客户',
    num: 0,
    id:"increaseLoanMonth"
  },
  {
    class: 'progress progress-img',
    isBigImg: false,
    span:6,
    isProgress: false,
    icon:'statistics7',
    name: '本月提交进件',
    num: 0,
    id:"increaseCommitMonth"
  },
  {
    class: 'progress progress-img',
    isBigImg: false,
    span:6,
    isProgress: false,
    icon:'statistics8',
    name: '本月弃单数',
    num: 0,
    id:"increaseDiscardMonth"
  },
  {
    class: 'progress progress-img',
    isBigImg: false,
    span:6,
    isProgress: false,
    icon:'statistics10',
    name: '本月放款数',
    num: 0,
    id:"increaseLendingMonth"
  },
  {
    class: 'progress progress-img',
    isBigImg: false,
    span:6,
    isProgress: false,
    icon:'statistics9',
    name: '本月放款总额(元)',
    num: 0,
    id:"increaseLendingAmountMonth"
  },
  {
    class: 'progress progress-img',
    isBigImg: false,
    span:6,
    isProgress: false,
    icon:'statistics14',
    name: '全年放款额(元）',
    num: 0,
    id:"increaseLendingAmountYear"
  },
  {
    class: 'progress progress-img',
    isBigImg: false,
    span:6,
    isProgress: false,
    icon:'statistics11',
    name: '全年新增客户',
    num: 0,
    id:"increaseLoanYear"
  },
  {
    class: 'progress progress-img',
    isBigImg: false,
    span:6,
    isProgress: false,
    icon:'statistics12',
    name: '全年成交客户',
    num: 0,
    id:"increaseCommitYear"
  },
  {
    class: 'progress progress-img',
    isBigImg: false,
    span:6,
    isProgress: false,
    icon:'statistics13',
    name: '全年弃单客户',
    num: 0,
    id:"increaseDiscardYear"
  },
  {
    class: 'progress progress-img',
    isBigImg: false,
    span:6,
    isProgress: false,
    icon:'statistics15',
    name: '业绩均值',
    num: 0,
    id:"carAmount"
  },
  {
    class: 'progress progress-img',
    isBigImg: false,
    span:6,
    isProgress: false,
    icon:'statistics16',
    name: '鹊喜租车A(万元）',
    num: 0,
    id:"typeOneAmountYear"
  },
  {
    class: 'progress progress-img',
    isBigImg: false,
    span:6,
    isProgress: false,
    icon:'statistics17',
    name: '鹊喜租车B(万元）',
    num: 0,
    id:"typeTHREEAmountYear"
  },
  {
    class: 'progress progress-img',
    isBigImg: false,
    span:6,
    isProgress: false,
    icon:'statistics18',
    name: '乾来租车(万元）',
    num: 0,
    id:"typeTENAmountYear"
  },
  {
    class: 'progress progress-img',
    isBigImg: false,
    span:6,
    isProgress: false,
    icon:'statistics19',
    name: '小鲸租车A(万元）',
    num: 0,
    id:"typeZEROAmountYear"
  },
  {
    class: 'progress progress-img',
    isBigImg: false,
    span:6,
    isProgress: false,
    icon:'statistics20',
    name: '小鲸租车B(万元）',
    num: 0,
    id:"typeTWOAmountYear"
  },
]

export const option = {
  height: 'auto',
  calcHeight: 30,
  tip: false,
  searchShow: true,
  // searchMenuSpan: 6,
  border: true,
  index: false,
  editBtn:false,
  delBtn: false,
  viewBtn: false,
  selection: false,
  addBtn:false,
  excelBtn: true,
  menu: false,
  headerAlign:'center',
  dialogClickModal: false,
  column: [
    {
      label: "公司名称",
      prop: "deptName",
    },
    {
      label: "新增客户数",
      display:false,
      children: [{
        label: '今日',
        prop: 'todayAddNewCustomers',
        display:false
      },{
        label: '昨日',
        prop: 'yesterdayAddNewCustomers',
        display:false
      },{
        label: '本月',
        prop: 'currentMonthAddNewCustomers',
        display:false
      },]
    },
    {
      label: "批款数",
      display:false,
      children: [{
        label: '今日',
        prop: 'todayNumberOfLoans',
        display:false
      },{
        label: '昨日',
        prop: 'yesterdayNumberOfLoans',
        display:false
      },{
        label: '本月',
        prop: 'currentMonthNumberOfLoans',
        display:false
      },]
    },
    {
      label: "批款金额（万元）",
      display:false,
      children: [{
        label: '今日',
        prop: 'todayAmountOfLoans',
        display:false
      },{
        label: '昨日',
        prop: 'yesterdayAmountOfLoans',
        display:false
      },{
        label: '本月',
        prop: 'currentMonthAmountOfLoans',
        display:false
      },]
    },
    {
      label: "批款均值（万元）",
      display:false,
      children: [{
        label: '今日',
        prop: 'todayAvgOfLoans',
        display:false
      },{
        label: '昨日',
        prop: 'yesterdayAvgOfLoans',
        display:false
      },{
        label: '本月',
        prop: 'currentMonthAvgOfLoans',
        display:false
      },]
    },
  ]
}
